/*    eslint indent: 0 */
export function changeColor(color) {
    return {
        type: 'myActionName_UpdateColor',
        payload: color
    };
}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/actions/colorAction.js
 **/